import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SignUpState {
  isLoading: boolean;
  error: string | false;
  tokenType: string;
  signup: any;
}

const initialState: SignUpState = {
  isLoading: false,
  error: false,
  tokenType: "Bearer",
  signup: null,
};

const slice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    signUpSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.signup = action.payload;
    },
    signUpFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Export the reducer
export default slice.reducer;

const { actions } = slice;



